export const link = `
  text-decoration: none;
  cursor: pointer;
`
